<template>
  <div class="cw-animate-pulse cw-flex cw-justify-between cw-p-2 cw-border cw-border-gray-200">
    <!-- Left Side -->
    <div class="cw-flex cw-flex-col">
      <!-- Location Name -->
      <div class="cw-w-28 cw-h-4 cw-mb-2.5 cw-mt-1 cw-bg-slate-300 cw-rounded" />
      <!-- Location Address -->
      <div class="cw-space-y-1.5">
        <div :class="`cw-w-40 cw-h-2 cw-bg-slate-300 cw-rounded`" />
        <div :class="`cw-w-32 cw-h-2 cw-bg-slate-300 cw-rounded`" />
        <div :class="`cw-w-20 cw-h-2 cw-bg-slate-300 cw-rounded`" />
      </div>
      <!-- Links -->
      <div class="cw-mt-6 cw-space-y-1.5">
        <div :class="`cw-w-24 cw-h-2.5 cw-bg-slate-300 cw-rounded`" />
        <div :class="`cw-w-36 cw-h-2.5 cw-bg-slate-300 cw-rounded`" />
      </div>
    </div>
    <!-- Right Side -->
    <div class="cw-flex cw-flex-col cw-items-end">
      <!-- Location Image -->
      <div class="cw-w-10 cw-h-3.5 cw-mb-2 cw-mt-1 cw-bg-slate-300 cw-rounded" />
      <!-- Enabled Features -->
      <div class="cw-space-y-1">
        <div v-for="i in 3"
          :key="i"
          class="cw-flex cw-justify-between cw-items-center cw-gap-x-1.5">
          <!-- Icon -->
          <div class="cw-rounded-full cw-bg-slate-300 cw-h-6 cw-w-6" />
          <!-- Feature -->
          <div class="cw-w-24 cw-h-2.5 cw-bg-slate-300 cw-rounded" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationItemSkeleton',
}
</script>
